import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div<{ expanded: boolean | undefined }>`
  transform-origin: 50% 50%;
  transition: all 0.25s ease-out;
  transform: ${(props) =>
    props.expanded ? "rotate(-180deg)" : "rotate(0deg)"};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledSvg = styled.svg`
  width: var(--icon-size);
  height: var(--icon-size);
  cursor: pointer;
`;

interface Props {
  className?: string;
  onClick?: () => void;
  expanded?: boolean;
}

export const ExpandIcon: React.FC<Props> = ({
  onClick,
  className,
  expanded,
}) => (
  <StyledRoot onClick={onClick} className={className} expanded={expanded}>
    <StyledSvg focusable="false" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
    </StyledSvg>
  </StyledRoot>
);
